import { render, staticRenderFns } from "./createInsurance.vue?vue&type=template&id=735dc52f&scoped=true"
import script from "./createInsurance.vue?vue&type=script&lang=js"
export * from "./createInsurance.vue?vue&type=script&lang=js"
import style0 from "./createInsurance.vue?vue&type=style&index=0&id=735dc52f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735dc52f",
  null
  
)

export default component.exports